var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    List\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2333984,6 L7.2333984,6 L7.2333984,8 L5.2333984,8 L5.2333984,6 Z M5.2333984,9 L7.2333984,9 L7.2333984,11 L5.2333984,11 L5.2333984,9 Z M5.2333984,12 L7.2333984,12 L7.2333984,14 L5.2333984,14 L5.2333984,12 Z M8.7998047,6.2988281 L14.7998047,6.2988281 L14.7998047,7.7988281 L8.7998047,7.7988281 L8.7998047,6.2988281 Z M8.7998047,9.2988281 L14.7998047,9.2988281 L14.7998047,10.7988281 L8.7998047,10.7988281 L8.7998047,9.2988281 Z M8.7998047,12.2988281 L14.7998047,12.2988281 L14.7998047,13.7988281 L8.7998047,13.7988281 L8.7998047,12.2988281 Z M20,0 L0,0 L0,20 L20,20 L20,0 Z M18.5,1.5 L18.5,18.5 L1.5,18.5 L1.5,1.5 L18.5,1.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.d121f7c319aca96a0d0545c1f83fa08b.svg";
export { ForwardRef as ReactComponent };